import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/lib/auth";
import Login from "@/pages/Login";
import AdminSaaS from "@/pages/AdminSaaS";
import Home from "@/pages/Home";
import Visite from "@/pages/Visite";
import Pazienti from "@/pages/Pazienti";
import Visita from "@/pages/Visita";
import Extra from "@/pages/Extra";
import Agenda from "@/pages/Agenda";
import Sedi from "@/pages/Sedi";
import RicercaTag from "@/pages/RicercaTag";
import Settings from "@/pages/Settings";
import Automazioni from "@/pages/Automazioni";
import PublicReport from "@/pages/PublicReport";
import PublicConsent from "@/pages/PublicConsent";

function Protected({ children, roles, centralOnly = false }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="flex h-screen items-center justify-center text-brand-navy">Caricamento…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/" replace />;
  if (centralOnly && user.email !== "admin@primevision.it") return <Navigate to="/" replace />;
  return children;
}

function RoleRouter() {
  const { user } = useAuth();
  if (!user) return <Navigate to="/login" replace />;
  if (user.role === "admin" && user.email === "admin@primevision.it") return <Navigate to="/admin" replace />;
  if (user.role === "medico") return <Navigate to="/home" replace />;
  // Any other legacy role: send to login (no SaaS access)
  return <Navigate to="/login" replace />;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster richColors position="top-right" />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/referto/:token" element={<PublicReport />} />
          <Route path="/paziente/consenso/:token" element={<PublicConsent />} />
          <Route path="/extra" element={<Extra />} />
          <Route path="/" element={<Protected><RoleRouter /></Protected>} />
          <Route path="/admin" element={<Protected roles={["admin"]} centralOnly><AdminSaaS /></Protected>} />
          <Route path="/home" element={<Protected roles={["medico"]}><Home /></Protected>} />
          <Route path="/visite" element={<Protected roles={["medico"]}><Visite /></Protected>} />
          <Route path="/pazienti" element={<Protected roles={["medico"]}><Pazienti /></Protected>} />
          <Route path="/visite/:vid" element={<Protected roles={["medico", "admin"]}><Visita /></Protected>} />
          <Route path="/agenda" element={<Protected roles={["medico"]}><Agenda /></Protected>} />
          <Route path="/sedi" element={<Protected roles={["medico"]}><Sedi /></Protected>} />
          <Route path="/ricerca-tag" element={<Protected roles={["medico"]}><RicercaTag /></Protected>} />
          <Route path="/automazioni" element={<Protected roles={["medico"]}><Automazioni /></Protected>} />
          <Route path="/impostazioni" element={<Protected roles={["medico"]}><Settings /></Protected>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
